<script lang="ts">
  import type { DataList } from '$provider/models/datalist/DataList';
  import New from './new/New.svelte';
  import Old from './old/Old.svelte';
  import { ListStyle } from '$shared/constants/ListStyle';

  interface Props {
    list?: IDataList;
    dataList?: DataList[];
    problems?: string[];
    style?: ListStyle;
    onevent?: (payload: any) => void;
  }

  let { list = {}, dataList = [], problems = [], style = ListStyle.None, onevent }: Props = $props();
</script>

<div class="comp-list">
  {#if Array.isArray(dataList) && dataList.length !== 0}
    <New list={dataList} {onevent} />
  {:else}
    <Old {list} {problems} {style} {onevent} />
  {/if}
</div>
